import _find from 'lodash/find';

export const getCurrentRoute = (routes, pathname) => {
  return _find(routes, route => route.path.split('/')[1] === pathname.split('/')[1]);
};
